export function meterUnitConversationRateAction(meterUnit, formUnit, formUnitValue) {
  if (meterUnit === 'cubic-feet' && formUnit === 'cubic-meters') {
    let num = formUnitValue * 35.32;
    return Number.parseFloat(num).toFixed(2);
  } else if (meterUnit === 'cubic-meters' && formUnit === 'cubic-feet') {
    let num = formUnitValue / 35.32;
    return Number.parseFloat(num).toFixed(2);
  } else if (meterUnit === 'gallons' && formUnit === 'liters') {
    let num = formUnitValue / 3.79;
    return Number.parseFloat(num).toFixed(2);
  } else if (meterUnit === 'gallons' && formUnit === 'cubic-meters') {
    let num = formUnitValue * 264.17;
    return Number.parseFloat(num).toFixed(2);
  } else if (meterUnit === 'gallons' && formUnit === 'cubic-feet') {
    let num = formUnitValue * 7.42;
    return Number.parseFloat(num).toFixed(2);
  } else if (meterUnit === 'liters' && formUnit === 'gallons') {
    let num = formUnitValue * 3.79;
    return Number.parseFloat(num).toFixed(2);
  } else if (meterUnit === 'liters' && formUnit === 'cubic-meters') {
    let num = formUnitValue * 1000;
    return Number.parseFloat(num).toFixed(2);
  } else if (meterUnit === 'liters' && formUnit === 'cubic-feet') {
    let num = formUnitValue * 28.32;
    return Number.parseFloat(num).toFixed(2);
  } else if (meterUnit === 'cubic-meters' && formUnit === 'cubic-feet') {
    let num = formUnitValue / 35.32;
    return Number.parseFloat(num).toFixed(2);
  } else if (meterUnit === 'cubic-meters' && formUnit === 'liters') {
    let num = formUnitValue / 1000;
    return Number.parseFloat(num).toFixed(2);
  } else if (meterUnit === 'cubic-meters' && formUnit === 'gallons') {
    let num = formUnitValue / 264.17;
    return Number.parseFloat(num).toFixed(2);
  } else if (meterUnit === 'cubic-feet' && formUnit === 'gallons') {
    let num = formUnitValue / 7.42;
    return Number.parseFloat(num).toFixed(2);
  } else if (meterUnit === 'cubic-feet' && formUnit === 'liters') {
    let num = formUnitValue / 28.32;
    return Number.parseFloat(num).toFixed(2);
  } else if (meterUnit === 'cubic-feet' && formUnit === 'cubic-meters') {
    let num = formUnitValue * 35.32;
    return Number.parseFloat(num).toFixed(2);
  } else {
    return formUnitValue;
  }
}
